export enum CONST {
  emptyGuid = '00000000-0000-0000-0000-000000000000', // emptyGuid is used in Routes when create new entity (localhost:3009/list/00000000-0000-0000-0000-000000000000)
  emailUrlParam = 'email',
  maxFileSize5MB = 5242880, // 5242880 Bytes = 5 Megabytes (MB) // https://www.flightpedia.org/convert/5-megabytes-to-bytes.html
}

export enum RoleOperation {
  add = 'Add',
  delete = 'Delete',
  deleteAll = 'DeleteAll',
}

// Common statuses for 3 `Article` fields (`Status`, `ModellStatus` and `ModellangebotStatus`)
export enum ArticleStatuses {
  released = 'Released',
  obsolete = 'Obsolete',
  firstRelease = 'FirstRelease',
  releasable = 'Releasable',
  discontinuedVME = 'DiscontinuedVME',
  inactive = 'Inactive',
  releasedAssortment = 'ReleasedAssortment',
}
